if (!customElements.get('product-media-gallery-wub')) {
  class ProductMediaGalleryWub extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.slides = Array.from(this.querySelectorAll('[data-media-slide]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-thumb-button]'));
      this.bullets = Array.from(this.querySelectorAll('[data-bullet-button]'));
      this.prevButton = this.querySelector('[data-gallery-prev]');
      this.nextButton = this.querySelector('[data-gallery-next]');
      this.variantsJson = this.querySelector('[data-gallery-variants]');
      this.viewport = this.querySelector('.wub-media-gallery__viewport');
      this.lightboxEnabled = this.dataset.lightboxEnabled === 'true';

      this.variantMap = [];

      try {
        this.variantMap = JSON.parse(this.variantsJson?.textContent || '[]');
      } catch (error) {
        this.variantMap = [];
      }

      if (!this.slides.length) return;

      this.activeIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));

      if (this.activeIndex < 0) {
        this.activeIndex = 0;
      }

      this.touch = {
        startX: 0,
        startY: 0,
        deltaX: 0,
        deltaY: 0,
        tracking: false
      };

      this.bindEvents();
      this.goToIndex(this.activeIndex, false, false);
      this.syncFromForm();
    }

    bindEvents() {
      this.thumbs.forEach((button) => {
        button.addEventListener('click', () => {
          this.activateByMediaId(button.dataset.mediaId, true, true);
        });
      });

      this.bullets.forEach((button) => {
        button.addEventListener('click', () => {
          this.activateByMediaId(button.dataset.mediaId, false, true);
        });
      });

      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => {
          this.goToIndex(this.activeIndex - 1, true, true);
        });
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => {
          this.goToIndex(this.activeIndex + 1, true, true);
        });
      }

      document.addEventListener('product:variant-change', (event) => {
        const variant = event?.detail?.variant;

        if (variant?.featured_media?.id) {
          this.activateByMediaId(String(variant.featured_media.id), false, false);
          return;
        }

        this.syncFromForm();
      });

      document.addEventListener('variant:change', (event) => {
        const variant = event?.detail?.variant || event?.detail;

        if (variant?.featured_media?.id) {
          this.activateByMediaId(String(variant.featured_media.id), false, false);
          return;
        }

        this.syncFromForm();
      });

      document.addEventListener('variant:changed', () => {
        this.syncFromForm();
      });

      document.addEventListener(
        'change',
        (event) => {
          const target = event.target;
          if (!target) return;

          if (target.name === 'id' || String(target.name || '').indexOf('options[') === 0) {
            window.requestAnimationFrame(() => this.syncFromForm());
          }
        },
        true
      );

      this.bindSwipe();
      this.bindZoom();
    }

    bindZoom() {
      if (!this.lightboxEnabled) return;

      this.querySelectorAll('[data-gallery-zoom]').forEach((link) => {
        link.addEventListener('click', (event) => {
          if (typeof PhotoSwipe === 'undefined' || typeof PhotoSwipeUI_Default === 'undefined') {
            return;
          }

          event.preventDefault();

          const currentSlide = event.currentTarget.closest('[data-media-slide]');

          const imageSlides = this.slides.filter((slide) => {
            const img = slide.querySelector('.wub-media-gallery__media img');
            const zoom = slide.querySelector('[data-gallery-zoom]');
            return !!img && !!zoom;
          });

          if (!imageSlides.length) return;

          const items = imageSlides.map((slide) => {
            const zoom = slide.querySelector('[data-gallery-zoom]');
            const img = slide.querySelector('.wub-media-gallery__media img');
            const fallbackSrc = img?.currentSrc || img?.src || '';

            return {
              src: zoom ? zoom.getAttribute('href') : fallbackSrc,
              msrc: fallbackSrc,
              w: parseInt(zoom?.dataset.pswpWidth || img?.naturalWidth || img?.getAttribute('width') || 1200, 10),
              h: parseInt(zoom?.dataset.pswpHeight || img?.naturalHeight || img?.getAttribute('height') || 1200, 10)
            };
          });

          const currentIndex = imageSlides.findIndex(
            (slide) => String(slide.dataset.mediaId) === String(currentSlide?.dataset.mediaId)
          );

          const pswpElement = document.querySelector('.pswp');
          if (!pswpElement) return;

          const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, {
            index: Math.max(0, currentIndex),
            maxSpreadZoom: 2,
            loop: false,
            allowPanToNext: false,
            closeOnScroll: false,
            showHideOpacity: false,
            arrowKeys: true,
            history: false,
            captionEl: false,
            fullscreenEl: false,
            zoomEl: false,
            shareEl: false,
            counterEl: true,
            arrowEl: true,
            preloaderEl: true
          });

          gallery.init();
        });
      });
    }

    bindSwipe() {
      if (!this.viewport) return;

      this.viewport.style.touchAction = 'pan-y pinch-zoom';

      this.viewport.addEventListener(
        'touchstart',
        (event) => {
          if (!event.touches || event.touches.length !== 1) return;

          const touch = event.touches[0];
          this.touch.startX = touch.clientX;
          this.touch.startY = touch.clientY;
          this.touch.deltaX = 0;
          this.touch.deltaY = 0;
          this.touch.tracking = true;
        },
        { passive: true }
      );

      this.viewport.addEventListener(
        'touchmove',
        (event) => {
          if (!this.touch.tracking || !event.touches || event.touches.length !== 1) return;

          const touch = event.touches[0];
          this.touch.deltaX = touch.clientX - this.touch.startX;
          this.touch.deltaY = touch.clientY - this.touch.startY;
        },
        { passive: true }
      );

      this.viewport.addEventListener(
        'touchend',
        () => {
          if (!this.touch.tracking) return;

          const absX = Math.abs(this.touch.deltaX);
          const absY = Math.abs(this.touch.deltaY);
          const threshold = 40;

          this.touch.tracking = false;

          if (absX < threshold) return;
          if (absY > absX) return;

          if (this.touch.deltaX < 0) {
            this.goToIndex(this.activeIndex + 1, true, true);
          } else {
            this.goToIndex(this.activeIndex - 1, true, true);
          }
        },
        { passive: true }
      );

      this.viewport.addEventListener(
        'touchcancel',
        () => {
          this.touch.tracking = false;
        },
        { passive: true }
      );
    }

    getCurrentVariantIdFromForm() {
      const sectionId = this.dataset.sectionId;
      const productForm = document.getElementById(`product-form-${sectionId}`);
      if (!productForm) return null;

      const input = productForm.querySelector('input[name="id"]');
      return input ? String(input.value || '') : null;
    }

    syncFromForm() {
      const variantId = this.getCurrentVariantIdFromForm();
      if (!variantId || !this.variantMap.length) return;

      const match = this.variantMap.find((variant) => String(variant.id) === String(variantId));

      if (match?.featured_media_id) {
        this.activateByMediaId(String(match.featured_media_id), false, false);
      }
    }

    activateByMediaId(mediaId, scrollThumb = true, userInitiated = false) {
      const index = this.slides.findIndex(
        (slide) => String(slide.dataset.mediaId) === String(mediaId)
      );

      if (index === -1) return;

      this.goToIndex(index, scrollThumb, userInitiated);
    }

    goToIndex(index, scrollThumb = true, userInitiated = false) {
      if (!this.slides.length) return;

      if (index < 0) index = 0;
      if (index > this.slides.length - 1) index = this.slides.length - 1;

      this.activeIndex = index;

      const activeSlide = this.slides[index];
      const activeMediaId = String(activeSlide?.dataset.mediaId || '');

      this.slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === index;

        slide.classList.toggle('is-active', isActive);
        slide.hidden = !isActive;
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      this.thumbs.forEach((button) => {
        const isActive = String(button.dataset.mediaId) === activeMediaId;

        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');

        if (isActive) {
          button.setAttribute('aria-current', 'true');

          if (scrollThumb && typeof button.scrollIntoView === 'function') {
            button.scrollIntoView({
              block: 'nearest',
              inline: 'nearest',
              behavior: userInitiated ? 'smooth' : 'auto'
            });
          }
        } else {
          button.removeAttribute('aria-current');
        }
      });

      this.bullets.forEach((button) => {
        const isActive = String(button.dataset.mediaId) === activeMediaId;

        button.classList.toggle('is-active', isActive);

        if (isActive) {
          button.setAttribute('aria-current', 'true');
        } else {
          button.removeAttribute('aria-current');
        }
      });

      this.updateNav();
    }

    updateNav() {
      if (this.prevButton) {
        this.prevButton.disabled = this.activeIndex <= 0;
      }

      if (this.nextButton) {
        this.nextButton.disabled = this.activeIndex >= this.slides.length - 1;
      }
    }
  }

  customElements.define('product-media-gallery-wub', ProductMediaGalleryWub);
}
